import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, ViewEncapsulation} from '@angular/core';
import {Meldung} from '../../models/meldung';

@Component({
    selector: 'lv-meldung-box',
    templateUrl: './meldung-box.component.html',
    styleUrls: ['./meldung-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MeldungBoxComponent implements OnChanges {
  @Input()
  public meldungen: Meldung[];

  constructor() {}

  public trackByFn(index: number, item: Meldung) {
    return item.Meldungstext;
  }

  ngOnChanges(): void {
    this.meldungen = this.meldungen?.filter(meldung => meldung.Quellsystemservice !== 'KDB');
  }
}
